import React from 'react';

export default function Pagination({ page, totalPages, total, perPage, onPageChange, onPerPageChange }) {
  const start = total ? (page - 1) * perPage + 1 : 0;
  const end = Math.min(page * perPage, total);

  const pages = [];
  for (let i = 1; i <= totalPages; i++) {
    if (totalPages > 7 && i > 2 && i < totalPages - 1 && Math.abs(i - page) > 1) {
      if (i === 3 || i === totalPages - 2) pages.push('...');
      continue;
    }
    pages.push(i);
  }

  const btnStyle = active => ({
    width: 30, height: 28, borderRadius: 5, border: '1px solid', cursor: 'pointer', fontSize: 12,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: active ? '#0f74b9' : '#fff',
    color: active ? '#fff' : '#343a40',
    borderColor: active ? '#0f74b9' : '#e9ecef',
  });

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 14px', borderTop: '1px solid #e9ecef', background: '#f8f9fa' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ fontSize: 12, color: '#6c757d' }}>Rows per page:</span>
        <select value={perPage} onChange={e => onPerPageChange(Number(e.target.value))}
          style={{ padding: '3px 6px', border: '1px solid #e9ecef', borderRadius: 5, fontSize: 11, color: '#6c757d' }}>
          {[10, 20, 50].map(n => <option key={n} value={n}>{n}</option>)}
        </select>
        <span style={{ fontSize: 12, color: '#6c757d' }}>Showing {start}–{end} of {total}</span>
      </div>
      <div style={{ display: 'flex', gap: 4 }}>
        <button type="button" style={{ ...btnStyle(false), opacity: page <= 1 ? .4 : 1 }} disabled={page <= 1} onClick={() => onPageChange(page - 1)}>‹</button>
        {pages.map((p, i) =>
          p === '...'
            ? <span key={i} style={{ padding: '0 4px', fontSize: 12, color: '#6c757d', display: 'flex', alignItems: 'center' }}>…</span>
            : <button type="button" key={p} style={btnStyle(p === page)} onClick={() => onPageChange(p)}>{p}</button>
        )}
        <button type="button" style={{ ...btnStyle(false), opacity: page >= totalPages ? .4 : 1 }} disabled={page >= totalPages} onClick={() => onPageChange(page + 1)}>›</button>
      </div>
    </div>
  );
}
